import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createPaalaegEvidenceQueryKey,
  createPaalaegPendingEvidenceQueryKey,
  getPendingPaalaegIndberetningEvidence,
  getReportEvidenceByPaalaeg,
  preparePaalaegIndberetningForSigning,
} from "@/api/paalaegIndberetning";
import type { PendingEvidenceResponse } from "@/interfaces/indberetning";
import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import type {
  PreparePaalaegIndberetningRequest,
  PreparePaalaegIndberetningResponse,
} from "@/interfaces/paalaegIndberetning";

export {
  createPaalaegEvidenceQueryKey,
  PAALAEG_INDBERETNING_QUERY_KEY,
} from "@/api/paalaegIndberetning";

export const usePreparePaalaegIndberetningForSigning = () =>
  useMutation<
    PreparePaalaegIndberetningResponse,
    Error,
    PreparePaalaegIndberetningRequest
  >({
    mutationFn: preparePaalaegIndberetningForSigning,
  });

export const useReportEvidenceByPaalaeg = (paalaegId?: string | null) =>
  useQuery<ReportEvidenceModel[]>({
    enabled: Boolean(paalaegId),
    queryKey: createPaalaegEvidenceQueryKey(paalaegId ?? ""),
    queryFn: () => getReportEvidenceByPaalaeg(paalaegId as string),
    staleTime: 5 * 60 * 1000,
  });

export const usePendingPaalaegIndberetningEvidence = (
  indberetningId?: string | null,
) =>
  useQuery<PendingEvidenceResponse>({
    queryKey: createPaalaegPendingEvidenceQueryKey(indberetningId ?? ""),
    queryFn: () =>
      getPendingPaalaegIndberetningEvidence(indberetningId as string),
    enabled: Boolean(indberetningId),
    staleTime: 5 * 60 * 1000,
  });
